import React from 'react'
import PropTypes from 'prop-types'

const SubscriberIcon = (props) => {
  const { color = '#183560', classes = 'w-20' } = props
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.16667 15V12H8.66667V10H6.16667V7H4.5V10H2V12H4.5V15H6.16667ZM12 13.75C10.05 13.75 6.16667 14.92 6.16667 17.25V19H17.8333V17.25C17.8333 14.92 13.95 13.75 12 13.75ZM8.11667 17C8.81667 16.42 10.5083 15.75 12 15.75C13.4917 15.75 15.1833 16.42 15.8833 17H8.11667ZM12 12C13.6083 12 14.9167 10.43 14.9167 8.5C14.9167 6.57 13.6083 5 12 5C10.3917 5 9.08333 6.57 9.08333 8.5C9.08333 10.43 10.3917 12 12 12ZM12 7C12.6917 7 13.25 7.67 13.25 8.5C13.25 9.33 12.6917 10 12 10C11.3083 10 10.75 9.33 10.75 8.5C10.75 7.67 11.3083 7 12 7ZM16.1667 12C17.775 12 19.0833 10.43 19.0833 8.5C19.0833 6.57 17.775 5 16.1667 5C15.9667 5 15.7667 5.02 15.575 5.07C16.2083 6.01 16.5833 7.2 16.5833 8.5C16.5833 9.8 16.1917 10.98 15.5583 11.92C15.7583 11.97 15.9583 12 16.1667 12ZM18.1 14.02C18.9333 14.83 19.5 15.89 19.5 17.25V19H22V17.25C22 15.56 19.9667 14.49 18.1 14.02Z"
        fill={color}
      />
    </svg>
  )
}

SubscriberIcon.propTypes = {
  color: PropTypes.string,
  classes: PropTypes.string,
}

export default React.memo(SubscriberIcon)
